import React, { useState } from 'react';
// import { AlertMessage } from 'src/web/components/AlertMessage/component';

import { ModalDialog } from 'src/web/components/Modals/ModalDialog';
import {
  RadioGroup,
  RadioOption,
} from 'src/web/components/RadioGroup/component';
import { ErrorMessage } from '../../../styles';

import { RadioOptionSubLabel } from './styles';

enum InstitutionRoles {
  ADMIN = 'admin',
  STAFF = 'staff',
}

interface ChangeInstitutionRoleModalProps {
  totalMembersAssigned: number;
  isLoading: boolean;
  error: string;
  onActionCallback: (role: InstitutionRoles) => void;
  onHide: () => void;
}

export const ChangeInstitutionRoleModal: React.FC<ChangeInstitutionRoleModalProps> = ({
  totalMembersAssigned,
  isLoading,
  error,
  onActionCallback,
  onHide,
}) => {
  const [selectedRole, setSelectedRole] = useState<'' | InstitutionRoles>('');
  return (
    <>
      <ModalDialog
        show
        center
        small
        onHide={onHide}
        title="Remove from institution"
        actions={[
          {
            label: 'Cancel',
            onClick: onHide,
            type: 'default',
          },
          {
            label: 'Change role',
            showSpinner: isLoading,
            disabled: isLoading,
            onClick: () => onActionCallback(selectedRole as InstitutionRoles),
            type: 'primary-kelp',
          },
        ]}
      >
        {/* <AlertMessage
          kind="info"
          message={
            <>
              You can customise institution roles and permissions in{' '}
              <a href="#">Configure {'>'} Advanced settings</a>.
            </>
          }
        /> */}
        <RadioGroup
          label={`Select institution role to assign to ${totalMembersAssigned} team member${
            totalMembersAssigned > 1 ? 's' : ''
          }`}
          name="radio-group"
          onChange={(selectedValue) =>
            setSelectedRole(selectedValue as InstitutionRoles)
          }
          selectedValue={selectedRole}
          layout="vertical"
        >
          <RadioOption
            label="Institution administrator"
            value={InstitutionRoles.ADMIN}
          >
            {() => (
              <RadioOptionSubLabel>
                Can access all institution settings
              </RadioOptionSubLabel>
            )}
          </RadioOption>
          <RadioOption label="Course creator" value={InstitutionRoles.STAFF}>
            {() => (
              <RadioOptionSubLabel>
                Cannot access institution settings, but is allowed to create
                courses within the institution
              </RadioOptionSubLabel>
            )}
          </RadioOption>
        </RadioGroup>
        <br />
        <ErrorMessage>{error}</ErrorMessage>
      </ModalDialog>
    </>
  );
};
